import React from "react";


const RewardsProgram = () => {
  return (
    <>
      <div className="pricing-section-description pricing-description-para">
        <h5 className="disclaimer-subtitle">
          Right Lender Rewards Program – Terms & Conditions
        </h5>
        <p className="pricing-product-para">
          <span className="pricing-product-icon">●</span>
          Right Lender (Perukkal 100 Consultancy Private Limited) offers an
          introductory rewards program for customers who apply for and
          successfully disburse eligible loans through Right Lender’s platform —
          including its website and Android/iOS apps. Eligible loans include
          Personal Loan, Business Loan, Doctor Loan, Home Loan, Loan Against
          Property, and NRI Personal Loans.
        </p>
      </div>

      <div className="pricing-section-description">
        <h4 className="disclaimer-subtitle">Offer Validity</h4>
        <p className="pricing-product-para">
          <span className="pricing-product-icon">●</span>
          This offer is valid for a limited time. Only loan applications
          initiated and successfully disbursed via Right Lender channels during
          this period are eligible. Right Lender reserves the right to modify,
          suspend, or withdraw the offer at any time without prior notice.
        </p>
      </div>

      <div className="pricing-section-description">
        <h4 className="disclaimer-subtitle">Eligibility Criteria</h4>
        <ul className="pricing-bullet-list pricing-product-para">
          <li>
            Customer must be at least 21 years old with valid identification
            (e.g., PAN card).
          </li>
          <li>
            Loans must be applied and disbursed through Right Lender’s official
            platforms or authorized communication channels.
          </li>
        </ul>
      </div>

      <div className="pricing-section-description">
        <h4 className="disclaimer-subtitle">Rewards Structure</h4>

        <div className="rewards-table-wrapper">
          <table className="rewards-table">
            <thead>
              <tr>
                <th>Loan Type</th>
                <th>Loan Amount Disbursed</th>
                <th>Reward Voucher Amount</th>
                <th>Maximum Cap</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowSpan="5">Personal / Business / Doctor</td>
                <td>₹10L to ₹19.99L</td>
                <td>₹2,000</td>
                <td rowSpan="5">₹10,000</td>
              </tr>
              <tr>
                <td>₹20L to ₹29.99L</td>
                <td>₹4,000</td>
              </tr>
              <tr>
                <td>₹30L to ₹39.99L</td>
                <td>₹6,000</td>
              </tr>
              <tr>
                <td>₹40L to ₹49.99L</td>
                <td>₹8,000</td>
              </tr>
              <tr>
                <td>₹50L and above</td>
                <td>₹10,000</td>
              </tr>

              <tr>
                <td>Home Loan / Mortgage / LAP</td>
                <td>₹50L minimum, plus ₹2,000 per additional ₹50L</td>
                <td>Up to ₹10,000</td>
                <td>₹10,000</td>
              </tr>

              <tr>
                <td>NRI Personal Loan</td>
                <td>Above ₹10L, ₹1,000 + ₹500 per ₹5L additional</td>
                <td>Up to ₹1,500</td>
                <td>₹1,500</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="pricing-section-description">
        <h4 className="disclaimer-subtitle">Referral Rewards</h4>
        <ul className="pricing-bullet-list pricing-product-para">
          <li>
            Earn ₹200 for every ₹1L disbursed through your referral (Min Loan
            Disbursal is 1 Lakh).
          </li>
          <li>Unlimited referrals allowed.</li>
          <li>Maximum referral rewards capped at ₹10,000 per referrer.</li>
          <li>
            Only customers who have received a loan disbursal through Right
            Lender are eligible to join and participate in the referral program.
            Leads or referrals from others will not be accepted.
          </li>
        </ul>
      </div>

      <div className="pricing-section-description">
        <h4 className="disclaimer-subtitle">Reward Distribution</h4>
        <ul className="pricing-bullet-list pricing-product-para">
          <li>
            Rewards will be issued as vouchers or e-card coupons from popular
            brands such as Amazon, Flipkart, MakeMyTrip, or other reputed
            partners, sent to the registered email ID and mobile number after
            the first EMI payment is successfully made.
          </li>
          <li>
            Voucher issuance may take up to 45 working days after confirmation
            of disbursal.
          </li>
          <li>
            Rewards will be issued only in the name of the customer whose loan
            has been disbursed through Right Lender and cannot be issued to any
            other individual or name.
          </li>
        </ul>
      </div>

      <div className="pricing-section-description">
        <h4 className="disclaimer-subtitle">Voucher Terms</h4>
        <ul className="pricing-bullet-list pricing-product-para">
          <li>
            Vouchers are non-transferable, non-exchangeable, and cannot be
            redeemed for cash.
          </li>
          <li>
            Vouchers must be used within the validity period specified by Right
            Lender.
          </li>
          <li>
            Right Lender is not responsible for lost, stolen, or misused
            vouchers.
          </li>
        </ul>
      </div>

      <div className="pricing-section-description">
        <h4 className="disclaimer-subtitle">Customer Consent</h4>
        <p className="pricing-product-para">
          <span className="pricing-product-icon">●</span>
          By participating, Customers consent to receive communication (calls,
          SMS, emails) from Right Lender or its partners for offer fulfilment.
        </p>
      </div>

      <div className="pricing-section-description">
        <h4 className="disclaimer-subtitle">Disclaimers & Legal</h4>
        <ul className="pricing-bullet-list pricing-product-para">
          <li>
            Loan approval and disbursal decisions rest solely with the lending
            institutions; Right Lender does not guarantee loan approval.
          </li>
          <li>
            Rewards are promotional and do not constitute a guaranteed monetary
            benefit.
          </li>
          <li>
            Right Lender reserves the right to disqualify Customers for
            fraudulent activity or misuse.
          </li>
          <li>Customers bear any tax liability arising from rewards.</li>
          <li>The offer is void where prohibited by law.</li>
          <li>
            Force majeure events may lead to withdrawal of the offer without
            notice.
          </li>
          <li>
            By participating, Customers indemnify Right Lender against claims
            arising from breach of these terms.
          </li>
          <li>
            This document is an electronic record under the Information
            Technology Act, 2000 and does not require any physical or digital
            signature.
          </li>
        </ul>
      </div>
    </>
  );
};

export default RewardsProgram;